module.exports = __webpack_public_path__ + "actions-arrow.fef3950ce75de5965abdcafc84964197.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/actions-arrow.svg
// module id = 1124
// module chunks = 0